module.exports = __webpack_public_path__ + "static/fonts/aeonik-regular.90cc3dd6.woff2";